<template>
<div class="site container hfeed">
  <HeadNav selectedLanguage="en" page="gb" />
  <article class="seo-topic-page">
    <SeoBreadcrumb :items="breadcrumbItems" />
    <section class="blog-content">
      <h1><strong>GB WhatsApp Old Versions Download</strong></h1>
      <p>
        Looking for an earlier version of <router-link to="/">GB WhatsApp</router-link>? GB Wave provides an archive of previous releases, making it easy to download older APKs for compatibility, testing, or personal preference. Browse popular versions below and choose the one that best suits your Android device.
      </p>

      <div class="old-version-banner">
        <p>🟢 New Version Available</p>
        <p>
          GB WhatsApp v18.80 is now available with better stability, privacy improvements, and Android compatibility.
          <router-link to="/download/">Download v18.80</router-link>
        </p>
      </div>

      <h2>Why Download an Older Version?</h2>
      <p>The latest version is recommended for most users, but an older release may be a better choice in certain situations. Some Android devices work more smoothly with previous versions, while others simply prefer an older interface or specific features that have changed over time.</p>
      <p>You may want to download an old version if:</p>
      <ul>
        <li>Your device isn't compatible with the latest release.</li>
        <li>You prefer the previous interface or feature set.</li>
        <li>You're troubleshooting issues after an update.</li>
        <li>You need a specific version for testing or compatibility.</li>
      </ul>
      <blockquote class="home-note"><strong>Tip:</strong> If your device supports the latest version, it's generally recommended to use the newest release for improved stability and compatibility.</blockquote>

      <h2>Why Is GB WhatsApp v13.50 Still Popular?</h2>
      <p>Although several newer versions have been released, <strong>GB WhatsApp v13.50</strong> continues to receive attention from users searching for older APKs. Many people look for this version because they're familiar with its interface, use an older Android device, or want a release they've used before.</p>
      <p>If you're specifically looking for <strong>GB WhatsApp v13.50</strong>, you can find it in our version archive along with other previous releases. Before downloading, make sure the version is compatible with your device and always back up your chats before switching versions.</p>
      <blockquote class="home-note"><strong>Note:</strong> If your device supports the latest release, <strong>GB WhatsApp v18.80</strong> is generally the recommended choice because it includes newer features, improved compatibility, and bug fixes.</blockquote>

      <h2>Popular GB WhatsApp Old Versions</h2>
      <div class="version-cards">
        <article v-for="v in popularVersions" :key="v.name" class="version-cards__item">
          <h3>{{ v.name }}</h3>
          <ul>
            <li v-for="line in v.lines" :key="line">{{ line }}</li>
          </ul>
          <button type="button" class="gb-wave-btn gb-wave-btn--secondary" @click="goDownload">Download</button>
        </article>
      </div>

      <h2>Version Archive</h2>
      <table class="data-table version-archive-table">
        <thead>
          <tr>
            <th scope="col">Version</th>
            <th scope="col">Updated</th>
            <th scope="col">Android</th>
            <th scope="col">Size</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in archiveRows" :key="row.version">
            <th scope="row">{{ row.version }}</th>
            <td>{{ row.updated }}</td>
            <td>{{ row.android }}</td>
            <td>{{ row.size }}</td>
          </tr>
        </tbody>
      </table>

      <h2>How to Install an Older Version</h2>
      <p>Installing an older version follows the same process as the latest release. Before you begin, back up your chats if you're replacing an existing installation.</p>
      <ol class="install-timeline">
        <li class="install-timeline__item">
          <span class="install-timeline__dot" aria-hidden="true">1</span>
          <div class="install-timeline__body">Download the version you need.</div>
        </li>
        <li class="install-timeline__item">
          <span class="install-timeline__dot" aria-hidden="true">2</span>
          <div class="install-timeline__body">Enable <strong>Install Unknown Apps</strong> in Android Settings.</div>
        </li>
        <li class="install-timeline__item">
          <span class="install-timeline__dot" aria-hidden="true">3</span>
          <div class="install-timeline__body">Open the APK and complete the installation.</div>
        </li>
        <li class="install-timeline__item">
          <span class="install-timeline__dot" aria-hidden="true">4</span>
          <div class="install-timeline__body">Verify your phone number and restore your backup if available.</div>
        </li>
      </ol>

      <h2>Should You Use the Old Version?</h2>
      <p>Older versions can be useful for compatibility or personal preference, but they may not include the latest improvements or bug fixes. If your device supports the current release and you don't have a specific reason to use an older version, the latest version is generally the better choice.</p>
      <p>If you're experiencing problems after updating, trying a previous stable version may help identify whether the issue is version-related.</p>

      <h2>Frequently Asked Questions</h2>
      <FAQ :faqs="faqs" variant="home" />
    </section>
  </article>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/seo-guide-page.scss';
import '@/css/gb-wave-home.scss';
import HeadNav from '@/components/HeadNav.vue';
import SeoBreadcrumb from '@/components/SeoBreadcrumb.vue';
import FAQ from '@/components/FAQ.vue';
import apkDownload from '@/mixins/apkDownload';

export default {
  name: 'GbWhatsappOldVersion',
  components: { HeadNav, SeoBreadcrumb, FAQ },
  mixins: [apkDownload],
  data() {
    return {
      breadcrumbItems: [
        { label: 'Home', to: { name: 'en-gb' } },
        { label: 'Old Versions', current: true },
      ],
      popularVersions: [
        {
          name: 'GB WhatsApp v18.70',
          lines: ['Updated: Oct 2026', 'Android: 5.0+', 'Size: 94 MB', 'Stable release'],
        },
        {
          name: 'GB WhatsApp v18.60',
          lines: ['Updated: Apr 2026', 'Android: 5.0+', 'Size: 93 MB'],
        },
        {
          name: 'GB WhatsApp v18.50',
          lines: ['Updated: Feb 2026', 'Android: 5.0+', 'Size: 92 MB'],
        },
        {
          name: 'GB WhatsApp v18.40',
          lines: ['Updated: Dec 2025', 'Android: 5.0+', 'Size: 91 MB'],
        },
      ],
      archiveRows: [
        { version: 'v18.70', updated: 'Oct 2026', android: '5.0+', size: '94 MB' },
        { version: 'v18.60', updated: 'Mar 2026', android: '5.0+', size: '93 MB' },
        { version: 'v18.50', updated: 'Feb 2026', android: '5.0+', size: '92 MB' },
        { version: 'v18.40', updated: 'Dec 2025', android: '5.0+', size: '91 MB' },
        { version: 'v18.30', updated: 'Oct 2025', android: '5.0+', size: '90 MB' },
        { version: 'v18.20', updated: 'Aug 2025', android: '5.0+', size: '89 MB' },
        { version: 'v18.10', updated: 'Jun 2025', android: '5.0+', size: '88 MB' },
        { version: 'v18.00', updated: 'Apr 2025', android: '5.0+', size: '88 MB' },
      ],
      faqs: [
        {
          question: 'Which old version is the most popular?',
          answer: 'Recent stable releases, such as v18.70 and v18.60, are commonly chosen by users who need compatibility with older devices or prefer an earlier version.',
        },
        {
          question: 'Will I lose my chats if I install an older version?',
          answer: 'Not necessarily. If you create a local backup before changing versions, you can usually restore your chats during setup.',
        },
        {
          question: 'Can I update to the latest version later?',
          answer: 'Yes. You can install a newer version at any time. Backing up your chats before updating is always recommended.',
        },
        {
          question: 'Do old versions support Android 15?',
          answer: 'Older releases may not be fully optimized for newer Android versions. If you\'re using Android 15 or later, the latest GB WhatsApp version is generally recommended for better compatibility.',
        },
      ],
    };
  },
  methods: {
    goDownload() {
      this.$router.push({ name: 'en-download' });
    },
  },
};
</script>

<style scoped>
.old-version-banner {
  background: #e8f8f0;
  border-radius: 12px;
  padding: 16px;
  margin: 1.5rem 0;
}
.version-cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin: 1rem auto 2rem;
  max-width: 960px;
}
.version-cards__item {
  border: 1px solid #dceee4;
  border-radius: 12px;
  padding: 16px 14px;
  background: #fafcfb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 0;
}
.version-cards__item h3 {
  margin: 0 0 0.55rem;
  font-size: 0.95rem;
  line-height: 1.3;
  color: #141a22;
}
.version-cards__item ul {
  width: max-content;
  max-width: 100%;
  margin: 0 auto 0.85rem;
  padding-left: 1.1rem;
  list-style: disc;
  text-align: left;
}
.version-cards__item li {
  font-size: 0.85rem;
  line-height: 1.5;
  color: #5b6573;
  text-align: left;
}
.version-cards__item .gb-wave-btn {
  align-self: center;
  margin-top: 0;
  padding: 8px 18px;
  font-size: 0.88rem;
}
.home-note {
  background: #f0f7f4;
  border-left: 4px solid var(--gb-wave-green);
  padding: 12px 16px;
  margin: 1rem 0;
}

.version-archive-table {
  width: min(100%, 380px);
  margin: 1rem 0 2rem;
}

.version-archive-table th,
.version-archive-table td {
  font-size: 0.85rem;
  line-height: 1.35;
  padding: 6px 10px;
}

.version-archive-table thead th {
  background: #fff;
  font-weight: 700;
  color: #1a1f27;
}

.version-archive-table tbody th {
  font-weight: 700;
  color: #1a1f27;
  background: #fff;
  white-space: nowrap;
}

.version-archive-table td {
  white-space: nowrap;
}

@media (max-width: 900px) {
  .version-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .version-cards {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
